"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.page = exports.SSRPage = void 0;
var React = __importStar(require("react"));
var qs_1 = __importDefault(require("qs"));
var isClient_1 = __importDefault(require("../utils/isClient"));
var findLoadingComponent_1 = __importDefault(require("../router/findLoadingComponent"));
var routers_1 = require("../router/routers");
var connect_1 = require("./connect");
function SSRPageWrap(component, statesName) {
    return function (props) {
        var history = props.history;
        var modelState = props[statesName];
        var modelAction = props["$" + statesName];
        var historyState = routers_1.getHistoryState();
        var PageComponent = Array.isArray(component) ? component[0] : component;
        var FrameComponent = findLoadingComponent_1.default(history.location.pathname);
        React.useMemo(function () {
            if (isClient_1.default()) {
                if (historyState
                    && (historyState.mode === 'auto' || !historyState.mode)
                    && historyState.preload
                    && Object.keys(historyState.preload).length) {
                    modelAction.setData(historyState.preload);
                }
                var query = qs_1.default.parse(window.location.search.slice(1));
                modelAction.asyncData({
                    host: window.location.host,
                    pathname: history.location.pathname,
                    query: query,
                });
            }
        }, []);
        React.useEffect(function () { return function () {
            modelAction.__changeAsyncComplete__(false);
        }; }, []);
        if (FrameComponent
            && modelState.__asyncComplete__ !== true
            && !(historyState && historyState.preload && Object.keys(historyState.preload).length)) {
            return React.createElement(FrameComponent, null);
        }
        return React.createElement(PageComponent, __assign({}, props));
    };
}
function SSRPage(component, option) {
    var states = option.states;
    var statesName = typeof states === 'string' ? states : states[0];
    return connect_1.reduxConnect(SSRPageWrap(component, statesName), option);
}
exports.SSRPage = SSRPage;
function page(name) {
    return function (component) { return SSRPageWrap(component, name); };
}
exports.page = page;
//# sourceMappingURL=SSRReduxPage.js.map